module.exports = __webpack_public_path__ + "img/solution1.0a30b0c2.png";